import $ from 'jquery';
import { useEffect, useState } from 'react';
import { gsap } from 'gsap/dist/gsap';
import setScrollVideo from '../../../../public/assets/js/scrollVideo';

export default function scrollVideo({ detail }) {
    let video = null;
    const [videoState, setVideoState] = useState(false);
    const [currentWidth, setCurrentWidth] = useState(window.innerWidth);

    // console.log(videoElementTop);

    function mobileScreen() {
        return currentWidth < 767;
    }

    function initScrollVideo() {
        video = document.querySelector('.video-background');

        if (currentWidth > 767 && videoState === false) {
            setScrollVideo();
            setVideoState(true);
        } else if (currentWidth < 767 && videoState === true) {
            ScrollTrigger.kill();
            setVideoState(false);
        }
    }

    useEffect(() => {
        if (document.querySelector('.video-background') != null && !videoState) {
            initScrollVideo();
        }

        const handleWindowResize = () => {
            setCurrentWidth(window.innerWidth);
            initScrollVideo();
        };

        const ctx = gsap.context(() => {
            window.addEventListener('resize', handleWindowResize);

            // TODO: add scroll listener for first scroll

            // TODO: build in refresh() when video almost on screen
        });

        return () => {
            window.removeEventListener('resize', handleWindowResize);
            ctx.revert(); // <-- CLEANUP!
        };
    });

    return (
        <div className="portfolio-bg-area" id="scrollVideoTrigger">
            <video
                // src={`https://bandwerkplus.nl/klanten/www.bandwerk.nl/uploads/video/${detail.video}`}
                src="/assets/video/output.mp4"
                muted="muted"
                autoPlay={mobileScreen()}
                controls={mobileScreen()}
                className="video-background"
            />
        </div>
    );
}
